import { ShowIf } from '@apply/components';
import { useExperienceProjectTypeId } from '../../../fields/ExperienceFields';
import { ExperienceProjectType } from '@apply/constants';
import { ProjectType } from './components/ProjectType';
import { ConstructedAfterClosed } from './components/ConstructedAfterClosed';
import { RehabilitationBudget } from './components/RehabilitationBudget';

interface ProjectTypeInformationProps {
    experienceId: string | undefined;
    readOnly?: boolean;
}

export const ProjectTypeInformation: React.FC<ProjectTypeInformationProps> = ({ experienceId, readOnly = false }) => {
    const [projectType] = useExperienceProjectTypeId(experienceId);

    const showConstructedAfterClosed = projectType === ExperienceProjectType.PersonalResidence;

    const showRehabBudgetSpend = projectType === ExperienceProjectType.FixFlipRehab;

    return (
        <>
            <ProjectType
                experienceId={experienceId}
                required={true}
                readOnly={readOnly}
            />
            <ShowIf showIf={showConstructedAfterClosed}>
                <ConstructedAfterClosed
                    experienceId={experienceId}
                    required={true}
                />
            </ShowIf>
            <ShowIf showIf={showRehabBudgetSpend}>
                <RehabilitationBudget
                    experienceId={experienceId}
                    required={true}
                />
            </ShowIf>
        </>
    );
};
